import React from 'react';
import PropTypes from 'prop-types';
import {kebabCase, map} from 'lodash';
import classnames from 'classnames';
import Icon from 'shared/components/icon';

// stylesheet
import 'stylesheets/components/satisfaction-buttons.scss';

export const SATISFACTION_RATINGS = [
  {
    icon: 'frown-open',
    value: 'very_unsatisfied',
  },
  {
    icon: 'frown',
    value: 'unsatisfied',
  },
  {
    icon: 'meh',
    value: 'neutral',
  },
  {
    icon: 'smile',
    value: 'satisfied',
  },
  {
    icon: 'laugh',
    value: 'very_satisfied',
  },
];

export default class SatisfactionButtons extends React.Component {
  static propTypes = {
    // Variable that is keeping track of what the user selected
    satisfaction: PropTypes.string,
    // Function that takes the new selected value and returns a function
    onClick: PropTypes.func.isRequired,
    // Descriptive prefix used for click tracking
    trackPrefix: PropTypes.string.isRequired,
    className: PropTypes.string,
  };

  render() {
    const {satisfaction, onClick, trackPrefix, className} = this.props;

    return (
      <div className={classnames('shared-satisfaction-buttons', className)}>
        {map(SATISFACTION_RATINGS, ({icon, value}) => {
          const selected = satisfaction === value;
          const identifier = kebabCase(`${trackPrefix}-${value}`);

          return (
            <button
              key={identifier}
              className="shared-satisfaction-buttons-button"
              type="button"
              data-segment-track="button"
              data-button-name={identifier}
              onClick={onClick(value)}
              data-testid={`satisfaction-button-${value}`}
            >
              <Icon
                iconType={`${icon}${selected ? '' : '-l'}`}
                className={classnames('shared-satisfaction-buttons-icon', {
                  selected: satisfaction && selected,
                })}
              />
            </button>
          );
        })}
      </div>
    );
  }
}
